/** Debounce for Find search input and search/filter analytics. */
export const FIND_SEARCH_DEBOUNCE_MS = 500
